import { axios, Response } from '..'
import { AccessProfile } from '../operators/get-clinic-operators'
import { FolderVisibility } from './create-template'
export interface TemplateInterface {
  id: string
  name: string
  parentFolderId: string | null
  folders: TemplateInterface[]
  permissions: Permissions[]
  folderVisibility: FolderVisibility
}

export interface Permissions {
  permissions: Permission[]
}

export interface Permission {
  id: string
  templateGalleryId: string
  permissionInsideFolder: string
  accessProfile: AccessProfile
}

export const getTemplatesFolder = async (): Response<TemplateInterface[]> => {
  return axios.get('/v1/template-gallery')
}
